import { render, staticRenderFns } from "./UsersPrivilegeEnquiryReservations.vue?vue&type=template&id=0d5bbe03&scoped=true&"
import script from "./UsersPrivilegeEnquiryReservations.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEnquiryReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5bbe03",
  null
  
)

export default component.exports